import {UI} from "../../../../stem-core/ui/UIBase";
import {Card} from "../../ui/Card.jsx";
import {SimpleTable} from "../../../../dashboard/ui/SimpleTable.jsx";
import {FormatPaymentMethodDescription} from "../../../../blinkpay/common/PaymentMethodDescription.jsx";
import type {AdminUser} from "../../../../client/state/AdminUserStore.js";
import type {PaymentMethod} from "../../../../client/state/PaymentMethodStore";


interface UserPaymentMethodListOptions {
    user?: AdminUser;
}

export class UserPaymentMethodList extends UI.Element<UserPaymentMethodListOptions> {
    render() {
        const {user} = this.options;
        const userPaymentMethods = user.getPaymentMethods();
        const columns = [
            ["Id", (paymentMethod: PaymentMethod) => paymentMethod.id],
            ["Provider", (paymentMethod: PaymentMethod) => paymentMethod.paymentProcessor?.provider],
            ["Payment method", (paymentMethod: PaymentMethod) => FormatPaymentMethodDescription(paymentMethod)],
            ["Is Default", (obj: PaymentMethod) => obj.isPrimary ? "true" : "false"],
            ["Created at", (obj: PaymentMethod) => obj.createdAt],
        ]
        return (
            <Card title="Payment Methods">
                <SimpleTable entries={userPaymentMethods} columns={columns} />
            </Card>
        );
    }
}
